import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { MemberService } from './../../../rest/api/member.service';
import { AuthService } from './../../../services/auth.service';

@Component({
  selector: 'app-public-space-confirm',
  templateUrl: './public-space-confirm.component.html',
  styleUrls: ['./public-space-confirm.component.scss']
})
export class PublicSpaceConfirmComponent implements OnInit {
  @Input() selectedSpace;
  @Output() spaceEmitData = new EventEmitter();
  @ViewChild('closeModal') closeModal: ElementRef;
  confirmSpaceError;
  confirmSpaceSuccess;
  accessToken: any;
  publicLoader = false;

  constructor(
    public memberService: MemberService,
    public authService: AuthService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  submit(space) {
    const spaceId = space.uuid;
    this.publicLoader = true;
    this.memberService.publishSpace({
      Authorization: this.accessToken,
      id: spaceId
    }).subscribe((response: any) => {
      this.publicLoader = false;
      const spaceData = response && response.data;
      this.confirmSpaceSuccess = 'The space has been successfully made private.';
      setTimeout(() => {
        this.closeModal.nativeElement.click();
        this.spaceEmitData.emit(spaceData);
        this.resetErrorValues();
      }, 2000);
    }, err => {
      this.publicLoader = false;
      if (err.error && err.error.error) {
        this.confirmSpaceError = err.error.error;
      } else {
        this.confirmSpaceError = 'There was error while confirming status.';
        this.resetErrorValues();
      }
    });
  }

  resetErrorValues() {
    this.confirmSpaceSuccess = undefined;
    this.confirmSpaceError = undefined;
  }
}
